import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default function useSensorTypes() {
	const { t: $t } = useI18n()

	const SENSOR_TYPE_MAPS = {
		FUEL_TANK_LEVEL: 'fuel_tank_level',
		IGNITION: 'ignition',
		POWER_EXTERNAL: 'power_external',
		POWER_INTERNAL: 'power_internal',
		MILEAGE: 'mileage',
		AGGREGATE_MARK: 'aggregate_mark',
		DRIVER_MARK: 'driver_mark',
		FUEL_FLOW: 'fuel_flow',
		FUEL_COUNTER: 'fuel_counter',
		FUEL_MOMENT_FLOW: 'fuel_moment_flow',
		FREIGHT_WEIGHT: 'freight_weight',
		FREIGHT_TEMPERATURE: 'freight_temperature',
		ALARM_BUTTON: 'alarm_button',
		ENGINE_RATES_PER_MINUTES: 'engine_rates_per_minutes',
		ENGINE_TEMPERATURE: 'engine_temperature',
		GAS_DRIVER_MARK: 'gas_driver_mark',
		GAS_OPERATOR_MARK: 'gas_operator_mark',
		GAS_GUN_FLOW: 'gas_gun_flow',
		CUSTOM: 'custom',
		LIQUID_FLOW: 'liquid_flow',
		BUNKER_SCREW_ON: 'bunker_screw_on',
		PLAN_NORM: 'plan_norm',
		FACT_NORM: 'fact_norm',
		VARIATION_COEFFICIENT: 'variation_coefficient',
		EQUIPMENT_BUNKER_VOLUME: 'equipment_bunker_volume',
		LANDING_DISTANCE: 'landing_distance',
		SECTION_ON_OFF: 'section_on_off',
		PRESSURE: 'pressure',
		BUNKER_VOLUME_LEVEL: 'bunker_volume_level',
		EXTERNAL_MARK: 'external_mark',
		DOING_JOB: 'doing_job',
		UNLOADING: 'unloading',
		ENGINE_HOURS: 'engine_hours',
	}

	const sensorTypes = computed(() => [
		{
			title: $t('Fuel level in the tank'),
			value: SENSOR_TYPE_MAPS.FUEL_TANK_LEVEL,
		},
		{
			title: $t('Ignition'),
			value: SENSOR_TYPE_MAPS.IGNITION,
		},
		{
			title: $t('External power'),
			value: SENSOR_TYPE_MAPS.POWER_EXTERNAL,
		},
		{
			title: $t('Internal power'),
			value: SENSOR_TYPE_MAPS.POWER_INTERNAL,
		},
		{
			title: $t('Mileage'),
			value: SENSOR_TYPE_MAPS.MILEAGE,
		},
		{
			title: $t('Aggregate mark'),
			value: SENSOR_TYPE_MAPS.AGGREGATE_MARK,
		},
		{
			title: $t('Driver`s identifier'),
			value: SENSOR_TYPE_MAPS.DRIVER_MARK,
		},
		{
			title: $t('Fuel consumption'),
			value: SENSOR_TYPE_MAPS.FUEL_FLOW,
		},
		{
			title: $t('Fuel sensor'),
			value: SENSOR_TYPE_MAPS.FUEL_COUNTER,
		},
		{
			title: $t('Fuel consumption'),
			value: SENSOR_TYPE_MAPS.FUEL_MOMENT_FLOW,
		},
		{
			title: $t('Cargo weight'),
			value: SENSOR_TYPE_MAPS.FREIGHT_WEIGHT,
		},
		{
			title: $t('Freight temperature'),
			value: SENSOR_TYPE_MAPS.FREIGHT_TEMPERATURE,
		},
		{
			title: $t('Alarm button'),
			value: SENSOR_TYPE_MAPS.ALARM_BUTTON,
		},
		{
			title: $t('Motor speed per minute'),
			value: SENSOR_TYPE_MAPS.ENGINE_RATES_PER_MINUTES,
		},
		{
			title: $t('Engine temperature'),
			value: SENSOR_TYPE_MAPS.ENGINE_TEMPERATURE,
		},
		{
			title: $t('Driver`s identificator'),
			value: SENSOR_TYPE_MAPS.GAS_DRIVER_MARK,
		},
		{
			title: $t('Fuel operator identificator'),
			value: SENSOR_TYPE_MAPS.GAS_OPERATOR_MARK,
		},
		{
			title: $t('Gas station consumption'),
			value: SENSOR_TYPE_MAPS.GAS_GUN_FLOW,
		},
		{
			title: $t('Custom'),
			value: SENSOR_TYPE_MAPS.CUSTOM,
		},
		{
			title: $t('Fluid flow'),
			value: SENSOR_TYPE_MAPS.LIQUID_FLOW,
		},
		{
			title: $t('Bunker unload sensor'),
			value: SENSOR_TYPE_MAPS.BUNKER_SCREW_ON,
		},
		{
			title: $t('Planned rate'),
			value: SENSOR_TYPE_MAPS.PLAN_NORM,
		},
		{
			title: $t('Fact norm'),
			value: SENSOR_TYPE_MAPS.FACT_NORM,
		},
		{
			title: $t('Coefficient of variation'),
			value: SENSOR_TYPE_MAPS.VARIATION_COEFFICIENT,
		},
		{
			title: $t('Bunker volume'),
			value: SENSOR_TYPE_MAPS.EQUIPMENT_BUNKER_VOLUME,
		},
		{
			title: $t('Landing station'),
			value: SENSOR_TYPE_MAPS.LANDING_DISTANCE,
		},
		{
			title: $t('Section'),
			value: SENSOR_TYPE_MAPS.SECTION_ON_OFF,
		},
		{
			title: $t('Pressure'),
			value: SENSOR_TYPE_MAPS.PRESSURE,
		},
		{
			title: $t('Bunker volume level'),
			value: SENSOR_TYPE_MAPS.BUNKER_VOLUME_LEVEL,
		},
		{
			title: $t('External mark'),
			value: SENSOR_TYPE_MAPS.EXTERNAL_MARK,
		},
		{
			title: $t('Completed work'),
			value: SENSOR_TYPE_MAPS.DOING_JOB,
		},
		{
			title: $t('Unload'),
			value: SENSOR_TYPE_MAPS.UNLOADING,
		},
		{
			title: $t('Motorhours'),
			value: SENSOR_TYPE_MAPS.ENGINE_HOURS,
		},
	])

	const sensorTypesObj = computed(() => ({
		[SENSOR_TYPE_MAPS.FUEL_TANK_LEVEL]: {
			title: $t('Fuel level in the tank'),
			value: SENSOR_TYPE_MAPS.FUEL_TANK_LEVEL,
		},
		[SENSOR_TYPE_MAPS.IGNITION]: {
			title: $t('Ignition'),
			value: SENSOR_TYPE_MAPS.IGNITION,
		},
		[SENSOR_TYPE_MAPS.POWER_EXTERNAL]: {
			title: $t('External power'),
			value: SENSOR_TYPE_MAPS.POWER_EXTERNAL,
		},
		[SENSOR_TYPE_MAPS.POWER_INTERNAL]: {
			title: $t('Internal power'),
			value: SENSOR_TYPE_MAPS.POWER_INTERNAL,
		},
		[SENSOR_TYPE_MAPS.MILEAGE]: {
			title: $t('Mileage'),
			value: SENSOR_TYPE_MAPS.MILEAGE,
		},
		[SENSOR_TYPE_MAPS.AGGREGATE_MARK]: {
			title: $t('Aggregate mark'),
			value: SENSOR_TYPE_MAPS.AGGREGATE_MARK,
		},
		[SENSOR_TYPE_MAPS.DRIVER_MARK]: {
			title: $t('Driver`s identifier'),
			value: SENSOR_TYPE_MAPS.DRIVER_MARK,
		},
		[SENSOR_TYPE_MAPS.FUEL_FLOW]: {
			title: $t('Fuel consumption'),
			value: SENSOR_TYPE_MAPS.FUEL_FLOW,
		},
		[SENSOR_TYPE_MAPS.FUEL_COUNTER]: {
			title: $t('Fuel sensor'),
			value: SENSOR_TYPE_MAPS.FUEL_COUNTER,
		},
		[SENSOR_TYPE_MAPS.FUEL_MOMENT_FLOW]: {
			title: $t('Fuel consumption'),
			value: SENSOR_TYPE_MAPS.FUEL_MOMENT_FLOW,
		},
		[SENSOR_TYPE_MAPS.FREIGHT_WEIGHT]: {
			title: $t('Cargo weight'),
			value: SENSOR_TYPE_MAPS.FREIGHT_WEIGHT,
		},
		[SENSOR_TYPE_MAPS.FREIGHT_TEMPERATURE]: {
			title: $t('Freight temperature'),
			value: SENSOR_TYPE_MAPS.FREIGHT_TEMPERATURE,
		},
		[SENSOR_TYPE_MAPS.ALARM_BUTTON]: {
			title: $t('Alarm button'),
			value: SENSOR_TYPE_MAPS.ALARM_BUTTON,
		},
		[SENSOR_TYPE_MAPS.ENGINE_RATES_PER_MINUTES]: {
			title: $t('Motor speed per minute'),
			value: SENSOR_TYPE_MAPS.ENGINE_RATES_PER_MINUTES,
		},
		[SENSOR_TYPE_MAPS.ENGINE_TEMPERATURE]: {
			title: $t('Engine temperature'),
			value: SENSOR_TYPE_MAPS.ENGINE_TEMPERATURE,
		},
		[SENSOR_TYPE_MAPS.GAS_DRIVER_MARK]: {
			title: $t('Driver`s identificator'),
			value: SENSOR_TYPE_MAPS.GAS_DRIVER_MARK,
		},
		[SENSOR_TYPE_MAPS.GAS_OPERATOR_MARK]: {
			title: $t('Fuel operator identificator'),
			value: SENSOR_TYPE_MAPS.GAS_OPERATOR_MARK,
		},
		[SENSOR_TYPE_MAPS.GAS_GUN_FLOW]: {
			title: $t('Gas station consumption'),
			value: SENSOR_TYPE_MAPS.GAS_GUN_FLOW,
		},
		[SENSOR_TYPE_MAPS.CUSTOM]: {
			title: $t('Custom'),
			value: SENSOR_TYPE_MAPS.CUSTOM,
		},
		[SENSOR_TYPE_MAPS.LIQUID_FLOW]: {
			title: $t('Fluid flow'),
			value: SENSOR_TYPE_MAPS.LIQUID_FLOW,
		},
		[SENSOR_TYPE_MAPS.BUNKER_SCREW_ON]: {
			title: $t('Bunker unload sensor'),
			value: SENSOR_TYPE_MAPS.BUNKER_SCREW_ON,
		},
		[SENSOR_TYPE_MAPS.PLAN_NORM]: {
			title: $t('Planned rate'),
			value: SENSOR_TYPE_MAPS.PLAN_NORM,
		},
		[SENSOR_TYPE_MAPS.FACT_NORM]: {
			title: $t('Fact norm'),
			value: SENSOR_TYPE_MAPS.FACT_NORM,
		},
		[SENSOR_TYPE_MAPS.VARIATION_COEFFICIENT]: {
			title: $t('Coefficient of variation'),
			value: SENSOR_TYPE_MAPS.VARIATION_COEFFICIENT,
		},
		[SENSOR_TYPE_MAPS.EQUIPMENT_BUNKER_VOLUME]: {
			title: $t('Bunker volume'),
			value: SENSOR_TYPE_MAPS.EQUIPMENT_BUNKER_VOLUME,
		},
		[SENSOR_TYPE_MAPS.LANDING_DISTANCE]: {
			title: $t('Landing station'),
			value: SENSOR_TYPE_MAPS.LANDING_DISTANCE,
		},
		[SENSOR_TYPE_MAPS.SECTION_ON_OFF]: {
			title: $t('Section'),
			value: SENSOR_TYPE_MAPS.SECTION_ON_OFF,
		},
		[SENSOR_TYPE_MAPS.PRESSURE]: {
			title: $t('Pressure'),
			value: SENSOR_TYPE_MAPS.PRESSURE,
		},
		[SENSOR_TYPE_MAPS.BUNKER_VOLUME_LEVEL]: {
			title: $t('Bunker volume level'),
			value: SENSOR_TYPE_MAPS.BUNKER_VOLUME_LEVEL,
		},
		[SENSOR_TYPE_MAPS.EXTERNAL_MARK]: {
			title: $t('External mark'),
			value: SENSOR_TYPE_MAPS.EXTERNAL_MARK,
		},
		[SENSOR_TYPE_MAPS.DOING_JOB]: {
			title: $t('Completed work'),
			value: SENSOR_TYPE_MAPS.DOING_JOB,
		},
		[SENSOR_TYPE_MAPS.UNLOADING]: {
			title: $t('Unload'),
			value: SENSOR_TYPE_MAPS.UNLOADING,
		},
		[SENSOR_TYPE_MAPS.ENGINE_HOURS]: {
			title: $t('Motorhours'),
			value: SENSOR_TYPE_MAPS.ENGINE_HOURS,
		},
	}))

	return {
		SENSOR_TYPE_MAPS,
		sensorTypes,
		sensorTypesObj,
	}
}
